import validate from 'validate.js'

const constraints = {
  name: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
